import {
  BooleanValidation,
  ObjectValidation,
  StringValidation,
} from '../../../../../utils/component-validations';
import Menu from '../../../core/menu/base.gjs';
import NoResults from '../../../core/menu/no-results.gjs';
import Super from '../../../core/base.gjs';

export default class SpdsInputSearchMenuBase extends Super {
  arguments = [
    new BooleanValidation({ optional: ['multiselect'], required: ['open'] }),
    new ObjectValidation({ required: ['anchorElement'] }),
    new StringValidation({ optional: ['noResultsText'] }),
  ];

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @id={{@id}}
      @open={{@open}}
      @multiselect={{@multiselect}}
      class="spds-input-search-menu"
      data-test-spds-input-search-menu
      ...attributes
      {{this.validateArguments}}
    >
      {{yield}}

      {{#if @noItemsDisplayed}}
        <NoResults @text={{@noResultsText}} />
      {{/if}}
    </Menu>
  </template>
}
